module.exports = "/_next/static/images/youtube-c-icon-48c0a36c3d8f9ed5855ef4ab992d6fe1.svg";